import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router";
import Sidebar from "../../partials/aside/Sidebar";
import httpService from "../../../services/httpServices/httpServices";
import validateFormAddCategortTicket from "../../../validtions/forms/ticket/add-category";
import helperSpinner from "../../../helpers/spinner";

function EditCategoryTicket() {
  const history = useHistory();
  const params = useParams();
  const categoryTicketID = params.id;

  const initRole = {
    title: "",
  };
  const [categoryTicket, setCategoryTicket] = useState(initRole);

  const [message, setMessage] = useState();
  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getGetCategoryTicket();
  }, []);

  const editCategoryTicket = async (e) => {
    e.preventDefault();
    const title = document.getElementById("title").value;
    const resValidateFormAddCategoryTicket =
      validateFormAddCategortTicket(title);
    if (resValidateFormAddCategoryTicket != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resValidateFormAddCategoryTicket,
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }

    const bodyRequest = {
      title: title,
    };
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (await sendRequestEditCategoryTicket(bodyRequest)) {
      history.push("/ticket/category-ticket");
      return;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestEditCategoryTicket = async (bodyRequest) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/ticket/categories-ticket/" +
          categoryTicketID,
        bodyRequest,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getGetCategoryTicket = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let categoryTicket = await sendRequestGetCategoryTicket();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    setCategoryTicket({
      title: categoryTicket.title,
    });
  };

  const sendRequestGetCategoryTicket = async () => {
    const headersRequest = getHeaderForRequest();

    let categoryTicketInfo;
    try {
      categoryTicketInfo = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/ticket/categories-ticket/" +
          categoryTicketID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return;
    }

    return categoryTicketInfo.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar openItem="tickets" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">دسته جدید</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <form onSubmit={editCategoryTicket}>
                <div className="form-group">
                  <label>عنوان</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    defaultValue={categoryTicket.title}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-outline-primary">
                  ارسال
                </button>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EditCategoryTicket;
